import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Products from './Products'

/* eslint-disable no-confusing-arrow */
class ProductsContainer extends Component {
  downloadProspectHandler = () => {
    window.location = 'https://prospect-releases.irisvr.com/ProspectSetup.exe'
  }

  render() {
    const { widthClass } = this.props
    return (
      <Products
        widthClass={widthClass}
        downloadProspectHandler={this.downloadProspectHandler}
      />
    )
  }
}

ProductsContainer.propTypes = {
  widthClass: PropTypes.string.isRequired,
}

export default ProductsContainer
